import React from 'react';
// @ts-ignore
import emptyGalleryPlaceholderImage from '../../../../../../img/empty-gallery-placeholder.png';

interface EmptyGalleryPlaceholderProps {
    translate: (key: string) => string;
}

export const EmptyGalleryPlaceholder: React.FC<EmptyGalleryPlaceholderProps> = ({translate}) => (
    <div className='empty-gallery-wrapper'>
        <img src={emptyGalleryPlaceholderImage} alt='No images yet' />
        <div className='empty-gallery-text'>{translate('MAIN.VIEW.NO_IMAGES_YET')}</div>
    </div>
);
